import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitomatherancab() {



const cardData = {
  keyword: "Mumbai to Matheran Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Matheran cab services for travelers looking to escape the city and enjoy the serene hill station experience. Whether you are planning a weekend getaway, family vacation, romantic trip, or group outing, our cab service ensures a smooth and safe journey with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in hill driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Matheran cab services.",

topPlaces: [
  {
    title: "Charlotte Lake",
    description:
      "Charlotte Lake is a beautiful freshwater lake in Matheran, surrounded by lush greenery and hills. Visitors can enjoy nature walks, photography, and peaceful picnics along the shore. Traveling by cab ensures a comfortable journey from Mumbai and allows visitors to spend ample time exploring the lake and nearby walking trails without worrying about transport."
  },
  {
    title: "Louisa Point",
    description:
      "Louisa Point offers panoramic views of the surrounding Sahyadri hills, valleys, and waterfalls. It is a favorite spot for sunrise and sunset photography. A cab ride provides easy access to Matheran’s viewpoints, allowing travelers to reach Louisa Point comfortably and enjoy the scenic beauty at leisure."
  },
  {
    title: "Panorama Point",
    description:
      "Panorama Point is one of Matheran’s highest viewpoints, offering breathtaking 360-degree views of the Western Ghats and surrounding plains. Visitors can enjoy trekking, photography, and nature observation. Traveling by cab ensures convenient transport to the base, giving ample time to explore the trails and viewpoints comfortably."
  },
  {
    title: "Echo Point",
    description:
      "Echo Point is a popular attraction in Matheran known for the natural echo phenomenon. Visitors enjoy shouting and listening to their echoes amidst lush surroundings. A cab ride makes it easy to reach this spot, providing a stress-free way to explore Matheran’s unique natural features and scenic trails."
  },
  {
    title: "Monkey Point",
    description:
      "Monkey Point offers stunning views of the surrounding hills and valleys and is known for the playful monkeys that inhabit the area. Visitors can enjoy nature walks, photography, and sightseeing. Traveling by cab ensures safe and convenient access, allowing visitors to spend time at the viewpoint without transport concerns."
  },
  {
    title: "One Tree Hill Point",
    description:
      "One Tree Hill Point is a serene viewpoint in Matheran, perfect for photography, relaxation, and enjoying panoramic hill views. Visitors can trek to this spot along scenic trails. A cab service allows comfortable travel from Mumbai, ensuring sufficient time to explore multiple viewpoints and enjoy the tranquil environment."
  },
  {
    title: "Cavalry Hill",
    description:
      "Cavalry Hill is a scenic spot in Matheran offering lush green landscapes and peaceful walking trails. Visitors can enjoy bird watching, photography, and a calm environment away from city noise. Using a cab ensures easy access, making it convenient to explore this and other nearby attractions efficiently."
  },
  {
    title: "Matheran Market",
    description:
      "Matheran Market is the main shopping area where visitors can buy local handicrafts, souvenirs, snacks, and explore local culture. Travelers can combine sightseeing with shopping. A cab ride allows convenient access, giving flexibility to visit the market along with other attractions in Matheran without transport hassles."
  },
  {
    title: "Alexander Point",
    description:
      "Alexander Point is another scenic viewpoint in Matheran, offering panoramic views of valleys, hills, and waterfalls. Visitors can enjoy trekking, photography, and nature observation. A cab service ensures comfortable access, allowing visitors to plan their day efficiently while covering multiple attractions."
  },
  {
    title: "Louisa Point Waterfall",
    description:
      "Louisa Point Waterfall is a beautiful seasonal waterfall near Louisa Point, especially spectacular during the monsoon. Visitors can enjoy nature walks, photography, and relaxing by the waterfall. Traveling by cab provides easy access and enough time to explore this scenic spot along with nearby viewpoints and attractions."
  }
],




services: [
{
name: "Mumbai to Matheran Cab",
description: "Mumbai to Matheran cab service offers comfortable travel from the city to the peaceful hill station of Matheran. Our AC sedans, SUVs, and premium vehicles ensure a smooth highway journey up to the Matheran entry point. Professional drivers with experience on hill station routes ensure safe and timely travel. Pickup is available from homes, hotels, offices, railway stations, and Mumbai airport terminals. This service is perfect for weekend trips, family vacations, and romantic hill station getaways. Spacious seating and air-conditioned interiors ensure relaxed travel throughout the journey. Flexible one-way and round-trip booking options allow convenient travel planning. Transparent pricing and reliable service ensure a stress-free cab booking experience."
},
{
name: "Mumbai to Matheran Taxi",
description: "Mumbai to Matheran taxi service provides convenient and reliable transportation for travelers visiting the scenic hill station. Comfortable AC vehicles ensure pleasant highway travel and relaxed long-distance journeys. Experienced drivers are familiar with routes leading to Matheran’s entry point and ensure safe travel. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for couples, families, and tourists planning hill station holidays. Clean interiors and spacious seating ensure a comfortable travel experience. Flexible departure scheduling allows travelers to plan trips easily. Reliable taxi services ensure safe and enjoyable travel."
},
{
name: "Mumbai to Matheran Cab Service",
description: "Mumbai to Matheran cab service provides dependable transportation for travelers seeking a smooth hill station journey. Our fleet includes well-maintained AC sedans and SUVs designed for comfortable highway travel. Professional drivers ensure safe driving along the Mumbai–Matheran route. Pickup services are available from residential areas, hotels, offices, and Mumbai airport terminals. Ideal for sightseeing tours, family holidays, and weekend escapes. Spacious vehicles provide relaxed seating for long-distance travel. Flexible booking options allow travelers to schedule trips easily. Transparent pricing ensures a reliable and trustworthy cab service."
},
{
name: "Mumbai to Matheran Taxi Service",
description: "Mumbai to Matheran taxi service offers reliable road travel between the city and the beautiful hill station destination. Comfortable AC vehicles ensure a pleasant and relaxed journey along highway routes. Skilled drivers ensure safe travel and punctual arrivals. Pickup is available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for weekend trips, family vacations, and tourist visits. Spacious seating ensures comfortable travel for passengers. Flexible booking options allow travelers to plan trips conveniently. Affordable fares and professional service guarantee a smooth travel experience."
},
{
name: "Cab from Mumbai to Matheran",
description: "Cab from Mumbai to Matheran provides a private and comfortable travel option for visitors heading to the hill station. Our AC vehicles ensure smooth highway journeys and comfortable travel experiences. Professional drivers ensure safe driving and timely arrival at the destination. Pickup is available from any location across Mumbai including homes, offices, hotels, and airports. Ideal for couples, families, and small groups visiting Matheran. Spacious interiors ensure relaxed seating throughout the journey. Flexible departure timing allows convenient trip planning. Reliable cab services ensure safe and enjoyable travel."
},
{
name: "Taxi from Mumbai to Matheran",
description: "Taxi from Mumbai to Matheran offers dependable transportation for travelers seeking comfortable road travel. Our AC vehicles ensure pleasant highway journeys and relaxed travel conditions. Experienced drivers ensure safe driving and smooth navigation along major routes. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for family trips, tourist travel, and weekend vacations. Clean interiors and spacious seating ensure passenger comfort. Flexible departure options help travelers schedule their journey easily. Professional taxi service ensures reliable travel."
},
{
name: "Mumbai to Matheran Cab Booking",
description: "Mumbai to Matheran cab booking allows travelers to reserve vehicles quickly and conveniently for hill station travel. Online and phone booking options provide instant confirmation and easy scheduling. Comfortable AC vehicles ensure smooth highway journeys. Professional drivers ensure safe and punctual travel experiences. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourists visiting the peaceful hill station of Matheran. Flexible one-way and round-trip booking options are available. Reliable booking service ensures hassle-free travel planning."
},
{
name: "Mumbai to Matheran Taxi Booking Online",
description: "Mumbai to Matheran taxi booking online offers a fast and convenient reservation system for passengers planning hill station trips. Instant booking confirmation ensures travelers can schedule journeys easily. AC sedans and SUVs provide comfortable travel along the highway route. Experienced drivers ensure safe and professional driving services. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourists, couples, and families visiting Matheran. Flexible travel timing allows convenient scheduling. Reliable booking system ensures smooth and stress-free taxi reservations."
},
{
name: "Mumbai to Matheran Cab Price",
description: "Mumbai to Matheran cab price offers affordable and transparent travel options for passengers planning hill station trips. Clear pricing ensures travelers know the total cost before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for different travel needs. Comfortable seating and AC interiors ensure relaxed travel throughout the journey. Professional drivers ensure safe highway driving and timely arrival. Pickup services are available across Mumbai including airport terminals. Flexible travel options allow passengers to choose one-way or round-trip trips. Budget-friendly fares ensure convenient and reliable cab travel."
},
{
name: "Mumbai to Matheran Taxi Fare",
description: "Mumbai to Matheran taxi fare is calculated using transparent per-kilometer pricing to provide clear travel costs. Passengers can choose from various vehicle options depending on comfort and budget preferences. Our AC vehicles ensure smooth highway travel and relaxed journeys. Experienced drivers guarantee safe driving and punctual arrival. Pickup services are available from homes, hotels, offices, and airports across Mumbai. Ideal for families and tourists planning hill station visits. Flexible booking options allow easy trip planning. Reliable fare structure ensures a stress-free taxi booking experience."
},
{
name: "Mumbai to Matheran One Way Cab",
description: "Mumbai to Matheran one way cab service is perfect for travelers who need a drop service without paying return charges. This option helps reduce overall travel expenses while ensuring comfortable transportation. AC sedans and SUVs provide relaxed seating for long-distance travel. Professional drivers ensure safe highway driving and timely arrival. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourists visiting Matheran for short trips. Flexible departure timing ensures convenient scheduling. Reliable one-way cab service ensures comfortable and affordable travel."
},
{
name: "Mumbai to Matheran Round Trip Taxi",
description: "Mumbai to Matheran round trip taxi service offers complete travel convenience for tourists planning return journeys. Flexible return timing allows travelers to explore the hill station without rushing. Comfortable AC vehicles ensure relaxed travel throughout the trip. Professional drivers remain available for return travel according to passenger schedules. Pickup services are available across Mumbai including homes, hotels, and airport terminals. Ideal for weekend vacations and sightseeing tours. Spacious vehicles ensure comfortable travel for families and groups. Reliable round-trip taxi service ensures smooth travel planning."
},
{
name: "Mumbai to Matheran Hill Station Cab",
description: "Mumbai to Matheran hill station cab service provides comfortable travel for tourists visiting this eco-friendly hill destination. Our AC vehicles ensure smooth highway travel up to the Matheran entry point. Experienced drivers are familiar with hill station routes and ensure safe driving. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for couples, families, and weekend tourists. Spacious seating ensures relaxed travel throughout the journey. Flexible travel scheduling allows easy trip planning. Reliable hill station cab service ensures enjoyable travel."
},
{
name: "Mumbai to Matheran Innova Cab",
description: "Mumbai to Matheran Innova cab service provides spacious and comfortable travel for families and group travelers. The premium MPV offers ample seating and luggage capacity for hill station journeys. AC interiors ensure pleasant travel throughout the trip. Experienced drivers ensure safe and smooth highway driving. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for family vacations and group travel. Comfortable seating ensures a relaxing journey. Reliable Innova cab service ensures convenient hill station travel."
}
],

tableData: [
["Mumbai to Matheran Cab","Mumbai to Matheran Taxi"],
["Mumbai to Matheran Cab Service","Mumbai to Matheran Taxi Service"],
["Cab from Mumbai to Matheran","Taxi from Mumbai to Matheran"],
["Mumbai to Matheran Cab Booking","Mumbai to Matheran Taxi Booking Online"],
["Mumbai to Matheran Cab Price","Mumbai to Matheran Taxi Fare"],
["Mumbai to Matheran One Way Cab","Mumbai to Matheran Round Trip Taxi"],
["Mumbai to Matheran Hill Station Cab","Mumbai to Matheran Innova Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Hill Station Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with the Mumbai to Matheran hill station route. They are familiar with the road to Dasturi Naka, the entry point of Matheran, ensuring a safe and smooth journey through the scenic hill roads."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs follows a transparent pricing policy for Mumbai to Matheran cab services. We clearly share the per-kilometer rate, toll charges, and trip package details before booking so there are no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you want to start your Matheran trip early morning or travel late at night, Omshree Cabs provides 24/7 cab booking and customer support for your convenience."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained, fully air-conditioned vehicles that are regularly cleaned and sanitized. This ensures a comfortable and relaxing journey from Mumbai to Matheran."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We provide flexible travel options including one-way cabs, round trips, and same-day return packages. Travelers can customize their travel schedule according to their plans."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, spacious SUVs like Ertiga and Innova, and premium vehicles suitable for couples, families, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and airports anywhere in Mumbai. Our drivers arrive on time so your journey to Matheran begins smoothly without any travel hassle."
  },
  {
    WhyChooseheading: "Reliable Hill Station Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Mumbai to Matheran trips. Our punctual service, safe driving, and comfortable vehicles make your hill station travel relaxing and enjoyable."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Matheran by cab?", answer: "The distance from Mumbai to Matheran is approximately 90 km and the journey usually takes around 2–3 hours depending on traffic and road conditions." },
  { question: "Can the cab go directly to Matheran town?", answer: "No, private vehicles are allowed only up to Dasturi Naka. From there travelers can walk, take a horse ride, or use a hand-pulled cart to reach Matheran town." },
  { question: "Do you provide one-way Mumbai to Matheran cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services between Mumbai and Matheran." },
  { question: "Which vehicles are available for Mumbai to Matheran travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort requirements." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport for Matheran cab bookings." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, every vehicle provided by Omshree Cabs is fully air-conditioned for comfortable travel." },
  { question: "Do you offer same-day return trips?", answer: "Yes, same-day return cab packages from Mumbai to Matheran are available." },
  { question: "Can we stop during the journey for sightseeing or food?", answer: "Yes, passengers can request stops during the journey for meals, photos, or refreshments." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday seasons when Matheran receives many tourists." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Mehta",
    feedback:
      "Booked Omshree Cabs for our Mumbai to Matheran weekend trip. The driver was punctual and the vehicle was clean. The journey was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Shah",
    feedback:
      "Our family trip to Matheran with Omshree Cabs was excellent. On-time pickup, professional driver, and transparent pricing made the trip very pleasant.",
    rating: 5
  }
];























































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Matheran Cab",
  "description": "Book Mumbai to Matheran Cab with Omshree Cab for comfortable hill station travel. Reliable taxi service from Mumbai to Matheran with options like Innova and other cabs for one-way or round trips. Affordable fares, easy online cab booking, and safe travel for your Matheran trip.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2050"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Mumbai to Matheran Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Matheran Cab with Omshree Cab for comfortable travel. Taxi service from Mumbai to Matheran hill station with Innova and other cabs for one-way and round trips. Affordable fares and easy online cab booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/15.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitomatherancab;